<template>
    <div class="block">
        {{ beneficiaryID }} : {{ beneficiaryName }}
    </div>
    <div class="block">
        <input v-model="updateNote" class="input is-rounded" placeholder="Note (optional)">
    </div>
    <div v-if="!updateDone" class="justify-center" @click="updateNoteForRegisteredBeneficiary">
        <button class="button is-warning is-rounded" :class="[isLoading ? 'is-loading' : '']">Update</button>
    </div>
    <div v-else class="notification is-primary is-light">
        Note updated!
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            updateNote: this.note,
            updateDone: false
        }
    },
    props: ['eventID', 'beneficiaryID', 'note', 'beneficiaryName'],
    watch: {
        note(newValue) {
            this.updateNote = newValue;
            this.updateDone = false;
        }
    },
    methods: {
        async updateNoteForRegisteredBeneficiary() {
            this.isLoading = true;
            await this.$store.dispatch('events/updateNote', {
                eventID: this.eventID,
                beneficiaryID: this.beneficiaryID,
                note: this.updateNote
            });
            this.isLoading = false;
            this.updateDone = true;
        }
    }
}
</script>

<style scoped>
.justify-center {
    text-align: center;
}
</style>